import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'menuPackName',
  pure: true
})
export class MenuPackNamePipe implements PipeTransform {
  transform(menuPackId: number, currencyMeta: any): string {
    if (!currencyMeta?.Menus) return '';
    
    const allMenuPacks = currencyMeta.Menus.flatMap((menu: any) => menu.MenuPacks || []);
    const menuPack = allMenuPacks.find((mp: any) => mp.Id === menuPackId);
    return menuPack?.Name || '';
  }
}
